import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { confirmAlert } from 'react-confirm-alert';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

/* 컴포넌트 */
import ProductSearchForm from 'components/product/ProductSearchForm';

const Status = () => {
  const [checkOutList, setCheckOutList] = useState([{}]);
  const [search, setSearch] = useState({
    productName: '',
    warehouseSeq: '',
    productTypeMstSeq: '',
    productKindSeq: '',
  });

  useEffect(() => {
    Common.isLogin();

    getCheckOutList();
  }, []);

  const getCheckOutList = () => {
    Server.sendGet('product/out/list', search, getCheckOutListCallback).then();
  };

  const getCheckOutListCallback = res => {
    setCheckOutList(res?.['resultList']);
  };

  const changeStatus = item => {
    confirmAlert({
      title: 'Are you sure you want to return?',
      buttons: [{
        label: 'Yes',
        onClick: () => {

          Server.sendPost('product/status', {
            productSeq: item.productSeq,
            productStockSeq: item.productStockSeq,
            productStatus: 'I',
            productKind: item.fkProductKind,
          }, changeStatusCallback).then();
        }
      }, {
        label: 'No'
      }]
    });
  };

  const changeStatusCallback = () => {
    Common.errorMsg('Discard complete.');

    getCheckOutList();
  };

  return (
    <>
      <Inner>
        <Title>
          <TitHead>
            <i/>
            <h4>Product check out</h4>
          </TitHead>
        </Title>
        <ProductSearchForm
          search={search}
          setSearch={setSearch}
          getList={getCheckOutList}
        />
        <Content>
          <Table>
            <colgroup>
              <col width='10%'/>
              <col width='10%'/>
              <col width='10%'/>
              <col width='15%'/>
              <col width='5%'/>
              <col width='20%'/>
              <col width='20%'/>
              <col width='10%'/>
            </colgroup>
            <thead>
            <tr>
              <th>Warehouse</th>
              <th>Product Type</th>
              <th>Product Kind</th>
              <th>Product Name</th>
              <th>Quantity</th>
              <th>Reg Date</th>
              <th>Worker Name</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            {checkOutList?.map((item, idx) => (
              <tr key={idx}>
                <td>{item.warehouse}</td>
                <td>{item.productType}</td>
                <td>{item.productKind}</td>
                <td>{item.productName}</td>
                <td>{item.quantity}</td>
                <td>{item.regDate}</td>
                <td>{item.workerName}</td>
                <td>
                  {item.productStatus !== 'Discard' &&
                    <TitBtn onClick={() => changeStatus(item)}>
                      <span>Return</span>
                    </TitBtn>
                  }
                </td>
              </tr>
            ))}
            {Common.isEmpty(checkOutList) &&
              <tr>
                <td colSpan={9} className={'none-data'}>
                  There is no data to output.
                </td>
              </tr>
            }
            </tbody>
          </Table>
        </Content>
      </Inner>
    </>
  );
}

const Inner = styled.div`
  flex: 1;
  background: #ffffff;
`;

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }
`;

const SearchArea = styled.div`
  position: relative;
  margin-top: 35px;
  padding: 15px 20px;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  align-items: center;
  gap: 0 15px;
  width: 100%;

  & .react-datepicker__tab-loop {
    position: absolute;
  }
`;

const CateIn = styled.div`
  display: flex;
  align-items: center;
  gap: 0 20px;
`;

const Cate = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & label {
    font-weight: 400;
    font-size: 16px;
    color: #777777;
  }
`;

const CateInput = styled.input`
  width: 160px;
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  font-weight: 400;
  font-size: 16px;
  color: #777777;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  outline: none;
`;

const SearchBtn = styled.button`
  width: 120px;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  background: #a4a4a4;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;

  &:hover {
    background-color: #7e7e7e;
  }
`;

const Content = styled.div`
  margin-top: 35px;
  position: relative;
  height: 622px;
  overflow-y: scroll;
`;

const Table = styled.table`
  position: relative;

  & th {
    padding:15px 0;
    font-weight: 400;
    font-size: 18px;
    color: #777777;
    background: #f8f8f8;
    text-align: center;
    border-bottom: 1px solid #eeeeee;
    vertical-align: middle;
  }

  & td {
    padding: 10px 0;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    text-align: center;
    vertical-align: middle;
    border-bottom: 1px solid #eeeeee;
    border-left: 1px solid #eeeeee;
    height: 47px;
  }

  & thead {
    position: sticky;
    top: 0;
  }

  & tbody > tr {
    cursor: pointer;

    &:hover {
      & td {
        background: #f4f4f4;
      }
    }
  }

  & tr td.none-data {
    height: 572px;
    border: 0;
  }

  & tr td:first-child {
    border-left: none;
  }

  & tr:nth-child(even) {
    background: #fcfcfc;
  }
`;

const TitBtn = styled.button`
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  gap: 0 5px;
  background: ${props => (props['$Color'] ? '#0072b9' : '#a4a4a4')};
  border-radius: 5px;
  margin: auto;

  & span {
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
  }

  &:hover {
    background-color: ${props => (props['$Color'] ? '#075C97' : '#7e7e7e')};
  }
`;

export default Status;